/**
 * @prettier
 */
import {graphqlQuery} from '../utils/graphqlQuery';

const OPERATION_NAME = 'graphql_get_content_items';

const contentItemsQuery = `
    query ContentItems($listingId: String!, $state: AmenityState) {
        unitContentItems(id: $listingId, state: $state) {
            amenityName
            amenity {
                displayName
                tags
            }
            stringAttributeValues {
                attributeName
                attributeValue
            }
            availability
        }
        propertyContentItems(id: $listingId, state: $state) {
            amenityName
            amenity {
                attributes {
                    attributeName
                    attributeState
                    attributeType
                    localizedAttributeName
                }
                displayName
                state
                tags
            }
            stringAttributeValues {
                attributeName
                attributeValue
            }
            availability
        }
        unitMetadata(id: $listingId) {
            description
            featuresDescription
            unitName
        }
    }
`;

async function contentItemsGraphQl({listingId, locale}) {
    const params = {listingId, state: 'PREBOOKING'};

    return await graphqlQuery(OPERATION_NAME, contentItemsQuery, params, locale);
}

export default contentItemsGraphQl;
export {contentItemsGraphQl, OPERATION_NAME, contentItemsQuery};
